import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import { useSvgFetch } from 'hooks/useSvgFetch';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { DividingLine } from 'components/DividingLine/DividingLine';
import { Subnav } from 'components/Subnav';

import { getFooterLinks, getMetaNavLinks } from 'utils/AEMPropUtils';
import { getLexikonUrl } from 'utils/UrlUtil';
import { getFileExtension } from 'utils/getFileExtension';

import './css/HomePageFooter.sass';

const HomePageFooter = (props) => {
  const { logo, address } = props;
  const history = useHistory();
  const footerLogo = {
    image: useSvgFetch(logo) || logo,
    isSvg: getFileExtension(logo) === 'svg',
  };
  const footerNavLinks = getFooterLinks(props).filter(
    (navLink) => typeof navLink?.url === 'string' && navLink.url
  );

  return (
    <footer>
      <DividingLine />
      <div className="footer__container">
        <div className="footer__list">
          {footerNavLinks.map(({ title, url }, index) => {
            const isLexikon = url.includes('lexikon');
            return (
              <button
                key={index}
                type="button"
                onClick={() => {
                  if (isLexikon) {
                    window.location.assign(getLexikonUrl());
                  } else {
                    history.push(url);
                  }
                }}>
                {title}
              </button>
            );
          })}
        </div>
        <div className="footer__address">
          <div className="footer__address-inner-wrapper">
            {footerLogo.isSvg ? (
              <div
                className="footer__logo"
                dangerouslySetInnerHTML={{ __html: footerLogo.image }}
              />
            ) : (
              <div className="footer__logo-container">
                <img className="footer__logo" alt="logo" src={footerLogo.image} />
              </div>
            )}
            <div dangerouslySetInnerHTML={{ __html: address }} />
          </div>
        </div>
      </div>
      <Subnav navItems={getMetaNavLinks(props)} />
    </footer>
  );
};
HomePageFooter.propTypes = {
  logo: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};
MapTo(['e-fix/components/structure/footer'])(HomePageFooter);
